import React from 'react'
import styled from 'styled-components'

import ResponsiveFont from '../ResponsiveFont/ResponsiveFont'

// A PureComponent
const EventTexts = React.memo<{
    title: string
    message: string
    description: string
}>(({ title, message, description }) => {
    return (
        <>
            <Title>
                <ResponsiveFont ratio={20}>{title}</ResponsiveFont>
            </Title>
            <Message>
                <ResponsiveFont ratio={40}>{message}</ResponsiveFont>
            </Message>
            <Description>
                <ResponsiveFont ratio={40}>{description}</ResponsiveFont>
            </Description>
        </>
    )
})

export default EventTexts

const Title = styled.h1`
    font-family: TransferSans, 'Transfer Sans', sans-serif;
    font-weight: normal;
    margin: 2vh 0 0 0;
    text-align: start;
`

const Message = styled.div`
    font-weight: bold;
    margin: 2vh 0 0 0;
    text-align: start;
`

const Description = styled.div`
    margin: 5vh 0 0 0;
    text-align: start;
`
